import { TextLabel } from '@core/components/Inputs';
import { Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Tooltip } from '@material-ui/core';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import NP from 'number-precision';
import React, { useState } from 'react';
import { FaInfo } from 'react-icons/fa';

const VisualizarProdutos = ({ values }) => {
  const [page, setPage] = useState(0);

  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const valorCompra = values?.comprasProdutos
    ?.map(({ quantidade, valor }) => NP.times(quantidade || 0, valor || 0))
    .reduce((acc, valor) => NP.plus(acc, valor || 0), 0);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left">Nome do produto</TableCell>
              <TableCell align="center">Quantidade</TableCell>
              <TableCell align="right">Valor (R$)</TableCell>
              <TableCell align="right">Subtotal (R$)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values?.comprasProdutos
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((compraProduto) => {
                let tooltip = '';
                if (compraProduto?.produto?.descricaoDetalhada) {
                  tooltip = compraProduto?.produto?.descricaoDetalhada;
                }

                if (compraProduto?.imobilizado) {
                  if (tooltip) {
                    tooltip += ' - ';
                  }

                  tooltip += 'Consumo próprio/Ativo imobilizado';
                }
                return (
                  <TableRow>
                    <TableCell component="th" align="left">
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <p>{compraProduto?.produto?.nome}</p>
                        {(compraProduto?.imobilizado || compraProduto?.produto?.descricaoDetalhada) && (
                          <Tooltip title={tooltip} placement="right-end">
                            <button type="button" onClick={() => {}}>
                              <FaInfo size={16} />
                            </button>
                          </Tooltip>
                        )}
                      </div>
                    </TableCell>
                    <TableCell align="center">{compraProduto?.quantidade}</TableCell>
                    <TableCell align="right">{getCurrencySemSinalMonetario(compraProduto?.valor, 4)}</TableCell>
                    <TableCell align="right">
                      {getCurrencySemSinalMonetario(NP.times(compraProduto?.valor || 0, compraProduto.quantidade || 0))}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          className="pb-0"
          count={values?.comprasProdutos?.length}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage={false}
          page={page}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          onChangePage={handleChangePage}
          rowsPerPageOptions={[]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingTop: 0 }}>
        <TextLabel
          id="valorCompra"
          label="Valor total da compra (R$)"
          value={getCurrencySemSinalMonetario(valorCompra)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingTop: 0, marginBottom: 16 }}>
        <TextLabel id="observacao" label="Observação" value={values.observacao} />
      </Grid>
    </Grid>
  );
};

export default VisualizarProdutos;
